import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { getMessageHash } from '@iconik-io/shared-lib/src/utils/get_message_hash';

import { locationChange } from '../router/actions';
import type { Message, MessagesAppState } from './types';

const initialState: MessagesAppState = {};

export const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    showMessage: (state, action: PayloadAction<Message>) => {
      state[getMessageHash(action.payload)] = action.payload;
    },
    hideMessage: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(locationChange, (state) =>
      Object.fromEntries(
        Object.entries(state).filter(
          ([, message]) => message.persistOnNavigation,
        ),
      ),
    );
  },
});

export const { showMessage, hideMessage } = messagesSlice.actions;

export const messagesReducer = messagesSlice.reducer;
